import React, { Component } from "react";
import EmployeeDetailComponent from "../../components/Employees/EmployeeDetailComponent";

class EmployeeDetail extends Component {
  render() {
    return (
      <div>
        <EmployeeDetailComponent />
      </div>
    );
  }
}

export default EmployeeDetail;
